var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.594 42V30.3779C28.594 24.2863 29.3049 19.2901 30.7267 15.3893C32.2012 11.4885 34.6761 8.17557 38.1517 5.45038C41.6272 2.72519 45.5766 0.908397 50 0V9.29771C46.8931 11.1145 45.129 13.5458 44.7077 16.5916H50V42H28.594ZM0 42V30.3779C0 24.2863 0.7109 19.2901 2.1327 15.3893C3.60716 11.4885 6.08215 8.17557 9.55766 5.45038C13.0858 2.72519 17.0353 0.908397 21.406 0V9.29771C18.2991 11.1145 16.535 13.5458 16.1137 16.5916H21.406V42H0Z",
    fill: "url(#paint0_linear_2124_1110)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2124_1110",
    x1: 0,
    y1: 0,
    x2: 53.1993,
    y2: 4.54394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111109,
    stopColor: "#FFE656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480903,
    stopColor: "#FFFF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605904,
    stopColor: "#FFE656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF9C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.08b2ab1ddeadafe973a2b19ca7d45de6.svg";
export { ForwardRef as ReactComponent };